import {getSetting} from "@woocommerce/settings";
import {useSelect} from '@wordpress/data';
import {cartStore} from '@woocommerce/block-data';

export const DebugInfo = () => {
	const {
		cfsqData,
		debugInfo,
	} = useSelect((select) => {
		const store = select(cartStore);
		const cartData = store.getCartData();

		return {
			cfsqData: cartData?.extensions?.['contact-for-shipping-quote'] ?? false,
			debugInfo: cartData?.extensions?.['contact-for-shipping-quote']?.['debug_info'] ?? false,
		}
	})

	return <>
		{getSetting('wccsq/should_show_debug', false) === true && (
			<div style={{padding: '16px'}}>
				<strong>Quote ID:</strong><br/>
				{debugInfo?.quote_id ?? 'No quote found'} - {cfsqData.quote?.status}<br/>
				<strong>Address:</strong><br/>
				{debugInfo?.address_hash ?? 'No address'}<br/>
				<pre>{JSON.stringify(debugInfo?.address_data, null, 4)}</pre>
				<strong>Cart:</strong><br/>
				{debugInfo.cart_hash ?? 'No cart hash'}<br/>
				<pre>{JSON.stringify(debugInfo?.cart_data, null, 4)}</pre>
			</div>
		)}
	</>
}
